// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"732":"3423f398","977":"51c9add9"}[chunkId] + ".chunk.js";
};